import ChallengeChecklistContainer from './challenge_checklist_container';

const ChallengeChecklist = ChallengeChecklistContainer;
export default ChallengeChecklist;
